import React from "react";
import CrossIcon from "../../../icons/CrossIcon";

interface props {
  className?: string;
  childrenClassName?: string;
  userLoggedIn?: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
  open?: boolean;
  showCross?: boolean;
}
function CustomModalLayout({
  open,
  onClose,
  children,
  userLoggedIn,
  className,
  childrenClassName,
  showCross = true,
}: props) {
  if (!open) return null;

  return (
    <div className=" fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className={`bg-white w-[382px] flex flex-col shadow-lg relative ${className}`}
      >
        {/* Close icon */}
        {showCross && (
          <button
            className="absolute z-40 top-3 right-3 text-gray-500 hover:text-gray-800 "
            onClick={onClose}
          >
            <CrossIcon />
          </button>
        )}
        <div className={`flex flex-col flex-grow h-full ${childrenClassName}`}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default CustomModalLayout;
